<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
                   [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[showSearch]="showSearch"
                   [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Configuration</div>

    </div>
    <div class="modal-body">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="clientIdSpecific($event)">
                <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectField"
                    (change)="valueFunc($event.target.selectedIndex)">
                <option *ngFor="let fieldValue of fieldValues" [value]="fieldValue.id"
                >{{fieldValue.name}}</option>
            </select>
        </div>
        <div class="form-group" [hidden]="!hiddenRadio">
            <mat-radio-group aria-label="Select an option">
                <mat-radio-button value="1" (change)="adddescription()">Create & Add</mat-radio-button> &nbsp;&nbsp;
                <mat-radio-button value="2" (change)="changedescription()">Add</mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="form-group" [hidden]="fieldloader">
            <div class="form-group">
                <textarea class="form-control radius-0 font-13" placeholder="Enter query" [(ngModel)]="query"></textarea>
            </div>
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="editValue">
            </div>
            <div class="form-group" [hidden]="!sequence">
                <input class="form-control radius-0 font-13" placeholder="Enter Sequence Number" [(ngModel)]="sequenceNumber">
            </div>
            <button type="button" class="btn btn-success radius-0" (click)="submitUpdate()">Submit</button>
        </div>
        <div [hidden]="addloader">
            <div class="form-group" >
                <input type="text" class="form-control radius-0 font-13" placeholder="Add description"
                       [(ngModel)]="newDescription">
            </div>
            <button type="button" class="btn btn-success radius-0" (click)="save()">Submit</button>
        </div>
    </div>
</ng-template>
<notifier-container></notifier-container>
